import _ from "lodash";
import * as React from "react";
import { useState } from "react";
import { useLoc } from "../../hooks/useLoc";
import firstCapitalCase from "../../services/firstCapitalCase";
import { WeatherData } from "../../templates/fragments/weather-data";
import { ShowMoreAccordion } from "../shared/base/show-more-accordion";
import { Chart } from "./chart/chart";
export const ChartWrapper = ({ weatherData }: { weatherData: WeatherData }) => {
    const loc = useLoc();
    const [moreCharts, setMoreCharts] = useState(false);
    // TODO locale
    return (
        <div>
            <Chart weatherData={weatherData} className="mdmax:hidden" />
            <Chart
                weatherData={weatherData}
                fixedMeasures={["tmax", "tmin", "sst", "ppt"]}
                title={loc("common.weatherOverview")}
                className="md:hidden"
            />
            <ShowMoreAccordion
                onClick={(isOpen) => {
                    setMoreCharts(isOpen);
                }}
                label={`Show less charts`}
                labelClosed={`Show more charts`}
                initialOpen={false}
                className="md:hidden"
            />
            {moreCharts && (
                <Chart
                    weatherData={weatherData}
                    fixedMeasures={["wet"]}
                    title={`${firstCapitalCase(
                        loc("common.measures.wet")
                    )} ${loc("common.chart")}`}
                    className="md:hidden"
                />
            )}
            {moreCharts && _.some(weatherData.sunhrs, (v) => v != 0) && (
                <Chart
                    weatherData={weatherData}
                    fixedMeasures={["sunhrs"]}
                    title={`${firstCapitalCase(
                        loc("common.measures.sunhrs")
                    )} ${loc("common.chart")}`}
                    className="md:hidden"
                />
            )}
            {moreCharts && _.some(weatherData.ws, (v) => v != 0) && (
                <Chart
                    weatherData={weatherData}
                    fixedMeasures={["ws"]}
                    title={`${firstCapitalCase(
                        loc("common.measures.ws")
                    )} ${loc("common.chart")}`}
                    className="md:hidden"
                />
            )}
            {moreCharts && _.some(weatherData.rhm, (v) => v != 0) && (
                <Chart
                    weatherData={weatherData}
                    fixedMeasures={["rhm"]}
                    title={`${firstCapitalCase(
                        loc("common.measures.rhm")
                    )} ${loc("common.chart")}`}
                    className="md:hidden"
                />
            )}
        </div>
    );
};
